import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import TeamListLayer from "../components/TeamListLayer";
 
 
const HighlightListPage = () => {
  return (
    <>

 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Teams  </h5><Breadcrumb title="Teams" /></div>
 
        <TeamListLayer />
 
 
 
    </>
  );
};
 
export default HighlightListPage;
 
 